import React from 'react';
import { TextField } from '@mui/material';

interface NumberFieldProps {
  value: number | '' | null;
  onChange: (value: number | '') => void;
  autoFocus?: boolean;
  disabled?: boolean;
}

const NumberField: React.FC<NumberFieldProps> = ({ value, onChange, autoFocus, disabled }) => {
  return (
    <TextField
      variant="standard"
      fullWidth
      type="number"
      value={value ?? ''}
      onChange={(e) => {
        const val = e.target.value;
        onChange(val === '' ? '' : Number(val));
      }}
      autoFocus={autoFocus}
      disabled={disabled}
      placeholder="Enter a number..."
      sx={{
        '& .MuiInput-root': {
          fontSize: '1.25rem',
        },
        '& .MuiInput-input': {
          textAlign: 'center',
          py: 1,
          // Hide number spinners
          '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          MozAppearance: 'textfield',
        },
      }}
    />
  );
};

export default NumberField;
